import { useEffect } from "react";
import { useAuth, useGet } from "@onefront/react-sdk";
import { buildHeaders } from "../../../common-utils/buildHeaders";
import { TrashBinProps } from "../../types";
import { useClientInformationStore } from "../../../store/useClientInformationStore";
import { useFilters } from "../useFilters";
import DataFilter from "../../../document-page/components/table-headers/DataFilterTableHeader";

export function useGetTrashDocs({
  checkIfUploaded,
  dateFilters,
  documentFilterOption,
  hasMore,
  pageNumber,
  pageSize,
  workspaceId,
}: TrashBinProps) {
  const authData = useAuth();
  const { selectedTenant: currentCompany } = useClientInformationStore();
  const [filters] = useFilters();
  const clientId = currentCompany?.itemId;

  const queryParams = new URLSearchParams({
    workspaceId: workspaceId,
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
  });

  const { data, loading, hasLoaded, fetch, error } = useGet(
    `documentsApi://api/v1/documents/trashed?${queryParams}`,
    {
      lazy: true,
      headers: buildHeaders({ authData }),
    }
  );
  useEffect(() => {
    if (
      (hasMore && workspaceId && documentFilterOption === "CESTINO") ||
      checkIfUploaded
    ) {
      fetch();
    }
  }, [workspaceId, checkIfUploaded, filters, documentFilterOption]);

  return { data, loading, hasLoaded, fetch, error };
}
